<template>
    <div class="order-menu">
        <div class="order-menu-title">
            用户购买的商品：
        </div>
        <div class="order-menu-list">
            <div
                v-for="(value, key, index) in shoppingCommodities"
                :key="key">
                <OrderItem
                    :value="value"
                    :number="value.number"
                    :index="index"
                />
            </div>
        </div>
        <div class="order-menu-bottom-area">
            <div class="order-menu-count-number">
                共计: {{ orderNumber }} 件
            </div>
            <div
                v-on:click="confirm"
                class="order-menu-confirm-button">
                确认订单
            </div>
        </div>
    </div>
</template>

<script>
 import OrderItem from "./OrderItem.vue"
 import EventBus from "../event/event-bus.js"

 import { mapGetters } from 'vuex'

 export default {
     name: 'OrderList',
     props: {
     },
     components: {
         OrderItem
     },
     computed: {
         ...mapGetters([
             "orderNumber"
         ]),
         shoppingCommodities: {
             get() { return this.$store.getters.shoppingCommodities},
             set(value) { this.$store.commit('changeShoppingCommodities', value ) }
         },
     },
     methods: {
         confirm() {
             console.log("OrderList confirmOrder emit")

             EventBus.$emit("confirmOrder")
         },
     }
 }
</script>

<style scoped>
 .order-menu {
     width: 400px;
     user-select: none;
 }

 .order-menu-title {
     color: #333333;
     font-size: 16px;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .order-menu-list {
     overflow-y: scroll;
     width: 100%;
     height: 250px;
 }

 .order-menu-item-line {
     width: 100%;
     display: flex;
     flex-direction: row;
     align-items: center;
     height: 50px;
 }

 .order-menu-item-even-line {
     background-color: #F4F4F4;
 }

 .order-menu-bottom-area {
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     padding-top: 10px;
     padding-bottom: 10px;
 }

 .order-menu-count-number {
     color: #333333;
     font-size: 16px;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .order-menu-confirm-button {
     width: 140px;
     color: #FFFFFF;
     font-size: 16px;
     background-color: #5DC55C;
     border-radius: 5px;
     padding-left: 10px;
     padding-right: 10px;
     padding-top: 4px;
     padding-bottom: 4px;
     margin-left: 5px;
     margin-right: 10px;
     text-align: center;
     user-select: none;
 }
</style>
